import React from "react";
import { Footer } from "@bbnpm/bb-ui-framework";

const FooterComponent: React.FC = () => {
  return (
    <Footer copyright={2024}>
      <Footer.Links></Footer.Links>
    </Footer>
  );
};

export { FooterComponent as Footer };
